var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 30,
    viewBox: "0 0 5 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.25C3.4375 18.25 4.25 19.0625 4.25 20C4.25 20.9688 3.4375 21.75 2.5 21.75C1.53125 21.75 0.75 20.9688 0.75 20C0.75 19.0625 1.53125 18.25 2.5 18.25ZM2.5 13.25C3.4375 13.25 4.25 14.0625 4.25 15C4.25 15.9688 3.4375 16.75 2.5 16.75C1.53125 16.75 0.75 15.9688 0.75 15C0.75 14.0625 1.53125 13.25 2.5 13.25ZM4.25 10C4.25 10.9688 3.4375 11.75 2.5 11.75C1.53125 11.75 0.75 10.9688 0.75 10C0.75 9.0625 1.53125 8.25 2.5 8.25C3.4375 8.25 4.25 9.0625 4.25 10Z",
    fill: "#037CB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.4a3c218a399b46f987c193b1232ebf52.svg";
export { ForwardRef as ReactComponent };